import React from 'react';

export const rutaLabel = (ruta) => {
    return <span
        className="row px-0 align-items-center"
        style={{ width: "-webkit-fill-available" }}
    >
        <span
            className="col-12"
            style={{ minWidth: "100px", wordBreak: "break-all", overflowX: 'hidden' }}
        >
            {ruta.label}
        </span>
        <span
            className="col-12"
            style={{ minWidth: "100px", wordBreak: "break-all", overflowX: 'hidden', fontSize: "12px" }}
        >
            {ruta.sector}
        </span>
    </span>;    
};
